
import React, { Component } from 'react'
import MenuItem from 'material-ui/MenuItem'
import MasterDetailLayout from 'components/MasterDetailLayout'
import Header from 'components/Header'
import AddButton from 'components/AddButton'
import Hamburger from 'components/Hamburger'
import PropertiesTable from './Table'
import TransactionForm from '../transactionForm'
import FiltersPicker from 'components/FiltersPicker'
import Notifications from 'components/ListLayoutParts/Notifications'
import filtersActions from 'actions/filters'
import Search from 'components/Search'

export default class TransactionPage extends Component {
	render() {
		let { props } = this
		let detailID = props.routeParams.id
		let header = (style) => (
			<Header {...{style}}>
				<Hamburger />
				<div>
					<FiltersPicker entity={'transaction'} />
					<Notifications />
					{<div style={{
							float: "right"
						  , position: "relative"
						  , top: "-24px"
						  , left: "240px"}}
					>
						<Search  entity={'transaction'} id="search-transactions" style={{marginTop: "-8px"}}/><
					/div>}
				</div>
				<AddButton color="#FFF">
					<MenuItem value="bill" object={{type:'transaction/bill'}} primaryText="Bill" />
					<MenuItem value="invoice" object={{type:'transaction/invoice', date: new Date()}} primaryText="Invoice" />
					<MenuItem value="payment" object={{type:'transaction/invoice-payment', date: new Date()}} primaryText="Payment" />
				</AddButton>
			</Header>
		)
		return(
			<MasterDetailLayout
				header={header}
				master={props => <PropertiesTable {...props} detailID={detailID} />}
				detail={props => <TransactionForm {...props} id={detailID} /> }
				detailColumns={1}
				detailOpen={!!detailID}
			/>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/transactions/index.js